export const ErrorContents: { [key: string]: { [key: string]: string } } = {
  'de-DE': {
    generic: 'Etwas ist schiefgelaufen.',
    header: 'PayPal Später Bezahlen-Banner',
    inEligible:
      'Später Bezahlen ist nur für berechtigte Händler verfügbar. Wenn Sie glauben, dass Ihnen diese Meldung irrtümlich angezeigt wird, schreiben Sie uns oder wenden Sie sich an Ihre E-Commerce-Plattform.',
    invalidBNCode:
      '<i>bn_code</i> ist ungültig. Nur Zahlen, Buchstaben, Bindestriche oder Unterstriche eingeben.',
    invalidMerchantClientId:
      '<i>merchant_client_id</i> ist ungültig. Nur Zahlen, Buchstaben, Bindestriche oder Unterstriche eingeben.',
    invalidPartnerClientId:
      '<i>partner_client_id</i> ist ungültig. Nur Zahlen, Buchstaben, Bindestriche oder Unterstriche eingeben.',
    invalidPartnerName:
      '<i>partner_name</i> ist ungültig. Nur Buchstaben, Zahlen oder Leerzeichen eingeben.',
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      'Es ist ein Fehler aufgetreten. Versuchen Sie es später erneut oder wenden Sie sich an uns.',
    unavailable: 'Später Bezahlen ist nicht verfügbar.'
  },
  'en-AU': {
    generic: 'Something went wrong',
    header: 'PayPal Pay Later messaging',
    inEligible:
      'Pay Later is only available for eligible merchants. If you believe you are seeing this in error, you can send us a message or contact your commerce platform.',
    invalidBNCode:
      '<i>bn_code</i> is invalid. Enter numbers, letters, dashes, periods, or underscores only.',
    invalidMerchantIdentifier:
      '<i>merchant_identifier</i> is invalid. Enter numbers and letters only.',
    invalidMerchantClientId:
      '<i>merchant_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerClientId:
      '<i>partner_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerName: '<i>partner_name</i> is invalid. Enter letters, numbers, or spaces only.',
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      'Oops, looks like there has been an error. Please try again later or reach out to us for help.',
    unavailable: 'Looks like Pay Later is unavailable.'
  },
  'en-DE': {
    generic: 'Something went wrong',
    header: 'PayPal Pay Later messaging',
    inEligible:
      'Pay Later is only available for eligible merchants. If you believe you are seeing this in error, you can send us a message or contact your commerce platform.',
    invalidBNCode:
      '<i>bn_code</i> is invalid. Enter numbers, letters, dashes, periods, or underscores only.',
    invalidMerchantIdentifier:
      '<i>merchant_identifier</i> is invalid. Enter numbers and letters only.',
    invalidMerchantClientId:
      '<i>merchant_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerClientId:
      '<i>partner_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerName: '<i>partner_name</i> is invalid. Enter letters, numbers, or spaces only.',
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      'Oops, looks like there has been an error. Please try again later or reach out to us for help.',
    unavailable: 'Looks like Pay Later is unavailable.'
  },
  'en-ES': {
    generic: 'Something went wrong',
    header: 'PayPal Pay in 3 installments Messaging',
    inEligible:
      'Pay Later is only available for eligible merchants. If you believe you are seeing this in error, you can send us a message or contact your commerce platform.',
    invalidBNCode:
      '<i>bn_code</i> is invalid. Enter numbers, letters, dashes, periods, or underscores only.',
    invalidMerchantIdentifier:
      '<i>merchant_identifier</i> is invalid. Enter numbers and letters only.',
    invalidMerchantClientId:
      '<i>merchant_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerClientId:
      '<i>partner_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerName: '<i>partner_name</i> is invalid. Enter letters, numbers, or spaces only.',
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      'Oops, looks like there has been an error. Please try again later or reach out to us for help.',
    unavailable: 'Looks like Pay Later is unavailable.'
  },
  'en-FR': {
    generic: 'Something went wrong',
    header: 'PayPal Pay in 4X Messaging',
    inEligible:
      'Pay Later is only available for eligible merchants. If you believe you are seeing this in error, you can send us a message or contact your commerce platform.',
    invalidBNCode:
      '<i>bn_code</i> is invalid. Enter numbers, letters, dashes, periods, or underscores only.',
    invalidMerchantIdentifier:
      '<i>merchant_identifier</i> is invalid. Enter numbers and letters only.',
    invalidMerchantClientId:
      '<i>merchant_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerClientId:
      '<i>partner_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerName: '<i>partner_name</i> is invalid. Enter letters, numbers, or spaces only.',
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      'Oops, looks like there has been an error. Please try again later or reach out to us for help.',
    unavailable: 'Looks like Pay Later is unavailable.'
  },
  'en-GB': {
    generic: "We're sorry, something seems to have gone wrong",
    header: 'PayPal Pay in 3 Messaging',
    inEligible:
      'Pay Later is only available for eligible merchants. If you believe you are seeing this in error, you can send us a message or contact your commerce platform.',
    invalidBNCode:
      '<i>bn_code</i> is invalid. Enter numbers, letters, dashes, periods, or underscores only.',
    invalidMerchantIdentifier:
      '<i>merchant_identifier</i> is invalid. Enter numbers and letters only.',
    invalidMerchantClientId:
      '<i>merchant_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerClientId:
      '<i>partner_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerName: '<i>partner_name</i> is invalid. Enter letters, numbers, or spaces only.',
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      'Oops, looks like there has been an error. Please try again later or get in touch with us for help.',
    unavailable: 'Looks like Pay Later is unavailable.'
  },
  'en-IT': {
    generic: 'Something went wrong',
    header: 'PayPal Pay in 3 installments Messaging',
    inEligible:
      'Pay Later is only available for eligible merchants. If you believe you are seeing this in error, you can send us a message or contact your commerce platform.',
    invalidBNCode:
      '<i>bn_code</i> is invalid. Enter numbers, letters, dashes, periods, or underscores only.',
    invalidMerchantIdentifier:
      '<i>merchant_identifier</i> is invalid. Enter numbers and letters only.',
    invalidMerchantClientId:
      '<i>merchant_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerClientId:
      '<i>partner_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerName: '<i>partner_name</i> is invalid. Enter letters, numbers, or spaces only.',
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      'Oops, looks like there has been an error. Please try again later or reach out to us for help.',
    unavailable: 'Looks like Pay Later is unavailable.'
  },
  'en-US': {
    generic: 'Something went wrong',
    header: 'PayPal Pay Later messaging',
    inEligible:
      'Pay Later is only available for eligible merchants. If you believe you are seeing this in error, you can send us a message or contact your commerce platform.',
    invalidBNCode:
      '<i>bn_code</i> is invalid. Enter numbers, letters, dashes, periods, or underscores only.',
    invalidMerchantIdentifier:
      '<i>merchant_identifier</i> is invalid. Enter numbers and letters only.',
    invalidMerchantClientId:
      '<i>merchant_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerClientId:
      '<i>partner_client_id</i> is invalid. Enter numbers, letters, dashes, or underscores only.',
    invalidPartnerName: '<i>partner_name</i> is invalid. Enter letters, numbers, or spaces only.',
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      'Oops, looks like there has been an error. Please try again later or reach out to us for help.',
    unavailable: 'Looks like Pay Later is unavailable.'
  },
  'es-ES': {
    generic: 'Ha habido un problema',
    header: 'Banners de Paga en 3 plazos de PayPal',
    inEligible:
      'Pago aplazado solo está disponible para vendedores que cumplan los requisitos. Si crees que estás viendo este mensaje por error, podrás enviarnos un mensaje o ponerte en contacto con tu plataforma comercial',
    invalidBNCode:
      'El número <i>bn_code</i> no es válido. Incluye solo números, letras, guiones o guiones bajos.',
    invalidMerchantClientId:
      'El número <i>merchant_client_id</i> no es válido. Incluye solo números, letras, guiones o guiones bajos.',
    invalidPartnerClientId:
      'El número <i>partner_client_id</i> no es válido. Incluye solo números, letras, guiones o guiones bajos.',
    invalidPartnerName:
      'El nombre <i>partner_name</i> no es válido. Incluye solo letras, números o espacios.',
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      'Vaya, parece que ha habido un error. Inténtalo de nuevo más tarde o ponte en contacto con nosotros para obtener ayuda.',
    unavailable: 'Parece que Pago aplazado no está disponible.'
  },
  'fr-FR': {
    generic: 'Une erreur est survenue.',
    header: 'Messages Paiement en 4X PayPal',
    inEligible:
      "Paiement différé est disponible uniquement pour les marchands éligibles. Si vous pensez qu'il s'agit d'une erreur, envoyez-nous un message ou contactez votre plateforme commerciale.",
    invalidBNCode:
      "<i>bn_code</i> n'est pas valide. Saisissez uniquement des chiffres, des lettres, des tirets ou des traits de soulignement.",
    invalidMerchantClientId:
      "<i>merchant_client_id</i> n'est pas valide. Saisissez uniquement des chiffres, des lettres, des tirets ou des traits de soulignement.",
    invalidPartnerClientId:
      "<i>partner_client_id</i> n'est pas valide. Saisissez uniquement des chiffres, des lettres, des tirets ou des traits de soulignement.",
    invalidPartnerName:
      "<i>partner_name</i> n'est pas valide. Saisissez uniquement des lettres, des chiffres ou des espaces.",
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      "Il semblerait qu'une erreur se soit produite. Réessayez plus tard ou contactez-nous pour obtenir de l'aide.",
    unavailable: "Paiement en 4X n'est pas disponible."
  },
  'it-IT': {
    generic: 'Si è verificato un errore',
    header: 'Banner Paga in 3 rate di PayPal',
    inEligible:
      'Il Pagamento differito è disponibile solo per i commercianti idonei. Se credi che si tratti di un errore, puoi inviarci un messaggio o contattare la tua piattaforma di e-commerce.',
    invalidBNCode:
      '<i>bn_code</i> non è valido. Immetti solo numeri, lettere, trattini o underscore.',
    invalidMerchantClientId:
      '<i>merchant_client_id</i> non è valido. Immetti solo numeri, lettere, trattini o underscore.',
    invalidPartnerClientId:
      '<i>partner_client_id</i> non è valido. Immetti solo numeri, lettere, trattini o underscore.',
    invalidPartnerName: '<i>partner_name</i> non è valido. Immetti solo lettere, numeri o spazi.',
    invalidPlacements: `<i>placements</i> are invalid. Please enter at least one valid messaging placement, e.g., ['product', 'cart', 'checkout'].`,
    tryAgainLater:
      'Spiacenti, si è verificato un errore. Riprova più tardi o contattaci per ricevere assistenza.',
    unavailable: 'Sembra che il Pagamento differito non sia disponibile.'
  }
};
